import { Grid  } from '@mui/material';
import React, { useState } from 'react';
import { AcademicYearDTO, CustomerDTO, ProductDTO, SiteDTO } from '@beable/roster-backend-client-v1';
import { StyledPanelHeader } from '../Common/Layout/PanelHeader';
import CustomerSelector from '../Common/CustomerSelector';
import SiteSelector from '../Common/SiteSelector';
import ProductSelectList from '../Common/Selectors/ProductSelectList';
import AcademicYearSelector from '../Common/AcademicYearSelector';
import CustomerCard from '../Common/CustomerCard';
import theme from '../../theme/theme';

interface SidebarProps {
  title: string;
  onCustomerChange?: (customer: CustomerDTO) => void;
  onSiteChange?: (site: SiteDTO) => void;
  onProductChange?: (product: ProductDTO) => void;
  onAcademicYearChange?: (academicYear: AcademicYearDTO | undefined) => void;
}

/**
 * This is sidebar component that provides selectors for customer, site, product and academicYear.
 * 
 * @export
 * @param {SidebarProps} {
 *   title,
 *   onCustomerChange,
 *   onSiteChange,
 *   onProductChange,
 *   onAcademicYearChange
 * }
 * @return {*} 
 */
export default function Sidebar({
  title,
  onCustomerChange,
  onSiteChange,
  onProductChange,
  onAcademicYearChange,
}: SidebarProps): React.JSX.Element {
  const [customer, setCustomer] = useState<CustomerDTO>();
  const [site, setSite] = useState<SiteDTO>();
  const [product, setProduct] = useState<ProductDTO>();
  const [academicYear, setAcademicYear] = useState<AcademicYearDTO>();

  const handleCustomerChange = (customer: CustomerDTO) => {
    if (onCustomerChange) {
      onCustomerChange(customer);
    }
    setCustomer(customer);
  };

  const handleSiteChange = async (site: SiteDTO) => {
    if (onSiteChange) {
      onSiteChange(site);
    }
    setSite(site);
  }

  const handleProductChange = (product: ProductDTO) => {
    if (onProductChange) {
      onProductChange(product);
    }
    setProduct(product);
  }

  const handleAcademicYearChange = (academicYear: AcademicYearDTO | undefined) => {
    if (onAcademicYearChange) {
      onAcademicYearChange(academicYear);
    }
    setAcademicYear(academicYear);
  }

  return (
    <div id='customer-site-product-ay-sidebar'>
      <StyledPanelHeader header={title} />
      <Grid container size={12}>
        <CustomerSelector 
            onSelect={handleCustomerChange} 
        />
        <SiteSelector
          customerId={customer?.id ?? ''}
          onSelect={handleSiteChange}
        />
        <ProductSelectList
          productId={product?.id ?? ''}
          customerId={customer?.id ?? ''}
          siteId={site?.id ?? 0}
          onChange={handleProductChange}
        />
        <AcademicYearSelector
          siteId={site ? site.id : 0}
          handleSelection={handleAcademicYearChange}
          clearAcademicYear={!academicYear}
          disabled={!site}
        />
        <Grid sx={{ marginLeft: theme.spacing(2) }} size={11}>
          <CustomerCard customer={customer} />
        </Grid>
      </Grid>
    </div>
  );
}